var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 14.857,
    viewBox: "0 0 14.857 14.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    "data-name": "Rectangle 1747",
    width: 14.857,
    height: 14.857,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3129",
    "data-name": "Group 3129",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3128",
    "data-name": "Group 3128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M12.429,13.607H2.517A2.274,2.274,0,0,1,.2,11.385V2.328a.8.8,0,0,1,1.6,0c0,.07.087.149.211.149H12.429a.8.8,0,0,1,.8.8v9.531A.8.8,0,0,1,12.429,13.607ZM1.8,4.065v7.32a.676.676,0,0,0,.717.622h9.111V4.077H2.011A1.887,1.887,0,0,1,1.8,4.065Z",
    transform: "translate(-0.286 -0.665)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M11.418,3.7H2.012A1.782,1.782,0,0,1,.2,1.949,1.782,1.782,0,0,1,2.012.2h9.406a.8.8,0,0,1,.8.8V2.9A.8.8,0,0,1,11.418,3.7ZM2.012,1.8c-.124,0-.211.078-.211.149s.087.149.211.149h8.606V1.8Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    d: "M.379-.8A1.169,1.169,0,0,1,1.559.356,1.169,1.169,0,0,1,.379,1.511,1.169,1.169,0,0,1-.8.356,1.169,1.169,0,0,1,.379-.8Z",
    transform: "translate(9.741 7.021)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.d82349bad721f80d2fd58fb36953e7aa.svg";
export { ForwardRef as ReactComponent };